import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Empresa = lazy(() => import('../pages/empresa/page'));
const Servicios = lazy(() => import('../pages/servicios/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Contacto = lazy(() => import('../pages/contacto/page'));
const PoliticaCookies = lazy(() => import('../pages/politica-cookies/page'));
const AvisoLegal = lazy(() => import('../pages/aviso-legal/page'));
const PoliticaPrivacidad = lazy(() => import('../pages/politica-privacidad/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/empresa',
    element: <Empresa />,
  },
  {
    path: '/servicios',
    element: <Servicios />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/contacto',
    element: <Contacto />,
  },
  {
    path: '/politica-cookies',
    element: <PoliticaCookies />,
  },
  {
    path: '/aviso-legal',
    element: <AvisoLegal />,
  },
  {
    path: '/politica-privacidad',
    element: <PoliticaPrivacidad />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
